// v49.2 — Auth loading skeleton.
// Replaces the bare "Checking session…" string in AuthGate. Mirrors the
// sidebar + topbar shape so the layout shift on hydration is minimal —
// no jump when the user / no-user branch resolves.

export function AuthLoadingSkeleton() {
  return (
    <div className="flex min-h-screen">
      {/* Sidebar skeleton */}
      <aside className="w-60 shrink-0 bg-white border-r border-lc-line h-screen sticky top-0 flex flex-col">
        <div className="px-5 py-5 flex items-center gap-2">
          <div className="w-9 h-9 rounded-lg bg-lc-bg-2 animate-pulse" />
          <div className="w-24 h-3 rounded-full bg-lc-bg-2 animate-pulse" />
        </div>
        <nav className="flex-1 px-2 py-1 flex flex-col gap-1.5">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="px-3 py-2 rounded-lc-md">
              <div className="h-3 rounded-full bg-lc-bg-2 animate-pulse" style={{ width: `${60 + (i * 7) % 30}%` }} />
            </div>
          ))}
        </nav>
        <div className="px-3 py-3 border-t border-lc-line flex items-center gap-2.5">
          <div className="w-9 h-9 rounded-full bg-lc-bg-2 animate-pulse" />
          <div className="flex-1 flex flex-col gap-1">
            <div className="w-24 h-3 rounded-full bg-lc-bg-2 animate-pulse" />
            <div className="w-12 h-2 rounded-full bg-lc-bg-2 animate-pulse" />
          </div>
        </div>
        <div className="px-5 py-3 border-t border-lc-line">
          <div className="text-[9px] font-extrabold tracking-widest uppercase text-lc-faint">v49.9</div>
        </div>
      </aside>

      {/* Topbar + main skeleton */}
      <main className="flex-1 min-w-0">
        <header className="sticky top-0 bg-white border-b border-lc-line px-6 py-3 flex items-center gap-4">
          <div className="w-32 h-4 rounded-full bg-lc-bg-2 animate-pulse" />
          <div className="flex-1" />
          <div className="w-20 h-5 rounded-full bg-lc-bg-2 animate-pulse" />
        </header>
        <div className="p-10 max-w-3xl">
          <div className="space-y-3">
            <div className="w-2/3 h-5 rounded-full bg-lc-bg-2 animate-pulse" />
            <div className="w-1/2 h-3 rounded-full bg-lc-bg-2 animate-pulse" />
          </div>
          <div className="mt-8 rounded-lc-lg border border-lc-line bg-white p-6 space-y-3">
            <div className="w-1/3 h-4 rounded-full bg-lc-bg-2 animate-pulse" />
            <div className="w-full h-3 rounded-full bg-lc-bg-2 animate-pulse" />
            <div className="w-5/6 h-3 rounded-full bg-lc-bg-2 animate-pulse" />
          </div>
        </div>
      </main>
    </div>
  );
}
